import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const employee = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.EMPLOYEE_REQUEST:
      draft.loading = true;
      return draft;
    case ACTIONS.EMPLOYEE_SUGGESTION_REQUEST:
      draft.suggestionLoading = true;
      return draft;
    case ACTIONS.EMPLOYEE_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.EMPLOYEE_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.GET_ALL_EMPLOYEES_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.GET_EMPLOYEE_BY_ID_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.EMPLOYEE_SUGGESTION_ERROR:
      draft.suggestionLoading = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.EMPLOYEE_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default employee;
